import { extendTheme } from '@chakra-ui/react';
import components from './components';
import breakpoints from './foundations/breakpoints';
import { ThemeColors } from './foundations/colors';
import fonts from './foundations/fonts';
import fontSizes from './foundations/fontSizes';
import type { StyleFunctionProps } from '@chakra-ui/styled-system';
import { mode } from '@chakra-ui/theme-tools';

import '@fontsource/poppins/100.css';
import '@fontsource/poppins/200.css';
import '@fontsource/poppins/300.css';
import '@fontsource/poppins/400.css';
import '@fontsource/poppins/500.css';
import '@fontsource/poppins/600.css';
import '@fontsource/poppins/700.css';
import '@fontsource/poppins/800.css';
import '@fontsource/poppins/900.css';

const theme = extendTheme({
  styles: {
    global: (props: StyleFunctionProps) => ({
      html: {
        backgroundColor: '#EFEFEF',
        margin: 0,
        padding: 0,
      },
      body: {
        width: '100vw',
        height: '100vh',
        overflowX: 'hidden',
        fontFamily: 'body',
        color: mode('gray.800', 'whiteAlpha.900')(props),
        bg: mode('white', 'gray.800')(props),
        lineHeight: 'base',
      },
    }),
  },

  breakpoints,
  components,
  colors: ThemeColors,
  fonts,
  fontSizes,
});

export type Size = 'sm' | 'md' | 'lg' | 'xs';
export type Color =
  | 'primary'
  | 'neutral'
  | 'error'
  | 'warning'
  | 'white'
  | 'black';
export type Variant = 'outline' | 'ghost' | 'link';

export default theme;
